import React, { useState } from 'react';
import { Key } from 'lucide-react';
import UsuarioPermisosModal from './UsuarioPermisosModal.jsx';

/**
 * Botón "Permisos" por fila del listado de Usuarios (`ResourcePage` genérico +
 * `config/resources.js#usuarios.extraRowActions`). Componente propio (no una función
 * suelta como `botonPagar` de `resources.finanzas-cxc.jsx`) porque necesita estado
 * propio (abrir/cerrar modal) — una función plana invocada por fila violaría las
 * Reglas de los Hooks si usara `useState` directamente dentro del render de
 * `ResourcePage`. `hasPermiso` se recibe ya resuelto desde `ResourcePage` (que sí lo
 * obtiene una sola vez por render vía `useContext`), nunca se llama aquí un hook de
 * contexto dentro de un ciclo por fila.
 */
export default function PermisosButton({ row, recargar, hasPermiso }) {
  const [abierto, setAbierto] = useState(false);

  if (!hasPermiso('usuarios:permisos') || row.is_active === 'No') return null;

  return (
    <>
      <button
        title="Permisos" aria-label="Permisos"
        className="p-1.5 rounded-md text-success-600 hover:bg-slate-100"
        onClick={() => setAbierto(true)}
      >
        <Key size={15} />
      </button>
      {abierto && (
        <UsuarioPermisosModal
          usuario={row}
          onClose={() => setAbierto(false)}
          onGuardado={() => { setAbierto(false); recargar(); }}
        />
      )}
    </>
  );
}
